<template>
  <div>
    <search-bar
      @search="onSearch"
      name="pu_vendname,pu_buyername,pr_code,pr_detail,pr_spec,pr_orispeccode"
      placeholder="输入供应商、采购员、产品进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.pu_code+item.pd_detno"
        @click="gotoView(item)"
      >
        <div class="weui-cell__bd">
          <p>{{ item.pu_vendname }}</p>
          <p>{{item.pu_code}} #{{item.pd_detno}}</p>
          <p class="list-item-muted">{{item.pr_detail}}</p>
          <p class="list-item-muted" >
            <span v-if="item.pr_orispeccode">{{item.pr_orispeccode}}/</span>
            <span v-if="item.pr_spec">{{item.pr_spec}}</span>
          </p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'#,##0.#'">￥{{item.pu_total}}</p>
          <p>
            <span v-format="'#,##0.#'">{{item.pd_qty}}</span>
            &nbsp;{{item.pr_unit}}
          </p>
          <p class="list-item-muted" v-if="item.pd_acceptqty">
            已入&nbsp;
            <span v-format="'#,##0.#'">{{item.pd_acceptqty}}</span>
            &nbsp;{{item.pr_unit}}
          </p>
          <span v-else class="list-item-status warning">未入库</span>
        </div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">共：{{items.length}}条</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'">{{
        getTotal("pu_total")
      }}</em>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/purchase/report/purchaseDetail",
      filters: [
        {
          type: "date",
          name: "pu_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "已入库",
              condition: "pu_acceptstatuscode='TURNIN'"
            },
            {
              value: 2,
              label: "未入库",
              condition: "pu_acceptstatuscode='UNTURNIN'"
            },
            {
              value: 3,
              label: "部分入库",
              condition: "pu_acceptstatuscode='PART2IN'"
            },
            {
              value: 4,
              label: "已关闭",
              condition: "pu_acceptstatuscode='CLOSE'"
            }
          ]
        }
      ],
      params: {
        mode: "DETAIL",
        number: 1,
        size: 10
      }
    };
  },
  mounted() {
    this.doSearch()
  },
  methods: {
    gotoView(item) {
      this.$router.push({
        name: "PurchaseOrderReportDetail",
        params: {
          initData: Object.assign({}, item)
        }
      });
    }
  }
};
</script>

<style scoped>
.weui-cell{
  align-items: flex-start !important;
}
</style>